import Flickity from 'Flickity'

class ResearchArticles extends HTMLElement {
  constructor() {
    super()

    this.optionsFlkty = {
      cellAlign: 'left',
      prevNextButtons: false,
      wrapAround: true,
      pageDots: true,
    }

    const flkty = new Flickity(this, this.optionsFlkty)
    flkty.resize()
  }
}

customElements.define('research-articles', ResearchArticles)
